import { render, staticRenderFns } from "./CategoryManagementModal.vue?vue&type=template&id=0879a48f&scoped=true&"
import script from "./CategoryManagementModal.vue?vue&type=script&lang=js&"
export * from "./CategoryManagementModal.vue?vue&type=script&lang=js&"
import style0 from "./CategoryManagementModal.vue?vue&type=style&index=0&id=0879a48f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0879a48f",
  null
  
)

export default component.exports